import {useTask} from '@github-ui/agent-sessions/hooks/use-task'
import type {SessionState} from '@github-ui/agent-sessions/types/session'
import {isSessionState} from '@github-ui/agent-sessions/types/session'
import {generateTaskPathForRepo} from '@github-ui/agent-sessions/utils/generate-task-path'
import {getAPITaskState} from '@github-ui/agent-sessions/utils/task-helpers'
import {useMemo} from 'react'
import type {FixTaskInfo} from './FixFindingStatus'

export function deriveFixTaskInfo(
  ccaTaskId: string | undefined,
  taskData: ReturnType<typeof useTask>['data'],
  taskIsError: boolean,
): FixTaskInfo | undefined {
  if (!ccaTaskId) return undefined
  if (taskIsError) return {ccaTaskId, state: 'failed' as SessionState}
  if (!taskData) return {ccaTaskId, state: 'queued' as SessionState}
  const rawState = getAPITaskState(taskData)
  const state: SessionState = isSessionState(rawState) ? rawState : 'queued'
  return {ccaTaskId, state}
}

export function useFixTask({ccaTaskId, taskBasePath}: {ccaTaskId?: string; taskBasePath: string}) {
  const {data: taskData, isError: taskIsError} = useTask({taskId: ccaTaskId})

  const fixTask = useMemo(() => deriveFixTaskInfo(ccaTaskId, taskData, taskIsError), [ccaTaskId, taskData, taskIsError])

  const taskUrl = useMemo(() => {
    if (!ccaTaskId) return undefined
    const url = generateTaskPathForRepo({repositoryNwo: taskBasePath.replace(/^\//, ''), taskId: ccaTaskId})
    return url || undefined
  }, [ccaTaskId, taskBasePath])

  return {taskData, fixTask, taskUrl}
}
